import { Box } from '@mui/material';
import { HeaderBar, useMode } from '@schamburg-web/components';
import {
  LoginProvider,
  NewAccountStepper,
  ResetPassword,
} from '@schamburg-web/lakecounty';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LcMap from './components/LcMap/LcMap';
import LoginCheck from './components/Login/LoginCheck';

import AboutPage from './components/About/AboutPage';
import ConfirmError from './components/Login/ConfirmError';
import LoginForm from './components/Login/LoginForm';
import ModulesContainer from './components/ModulesContainer/ModulesContainer';
import AudioPlayerWithButton from './modules/Har/AudioPlayer';
import SocialMedia from './components/SocialMedia/SocialMedia';
import Unsubscribe from './components/Login/Unsubscribe';

const Layout: React.FC = () => {
  const { mode } = useMode();
  const navLocations = [
    {
      name: 'Home',
      link: '/',
      target: '_self',
      component: React.createElement(LcMap),
      showOnSelf: false,
    },
    {
      name: 'Email Notifications',
      link: '/notification',
      target: '_self',
      maxWidth: 100,
      component: React.createElement(LoginCheck),
    },
    {
      name: 'About',
      link: '/about',
      target: '_self',
      component: React.createElement(() => <AboutPage />),
    },
    {
      name: 'Listen',
      target: '_self',
      component: React.createElement(() => (
        <AudioPlayerWithButton src="https://www.lakecountypassage.com/har/iss_har_msg.mp3" />
      )),
    },
  ];

  return (
    <Box className={mode} sx={{ height: '100vh', width: '100%' }}>
      <Box component="header" role="banner">
        <HeaderBar
          logoClass={'logo'}
          appTitle={undefined}
          className={'app-header'}
          navLocations={navLocations}
          showSearchBox={false}
          showLocation={true}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginRight: 1.25,
              alignItems: 'center',
              height: '100%',
            }}
          >
            <SocialMedia />
          </Box>
        </HeaderBar>
      </Box>
      <main id="main-content" role="main">
        <Box sx={{ height: 'calc(100vh - 65px)', width: '100%' }}>
          <Routes>
            <Route
              path="/"
              element={
                <ModulesContainer>
                  <LcMap />
                </ModulesContainer>
              }
            />
            {/* Dynamically add routes for navLocations with a link */}
            {navLocations
              .filter((loc) => loc.link && loc.component)
              .map((loc) => (
                <Route key={loc.link} path={loc.link} element={loc.component} />
              ))}
            <Route path="/loginform" element={<LoginForm />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route path="/confirmerr" element={<ConfirmError />} />
            <Route
              path="/newaccount"
              element={
                <LoginProvider>
                  <NewAccountStepper />
                </LoginProvider>
              }
            />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
      </main>
    </Box>
  );
};

export default Layout;
